import { compact } from 'lodash';
import { faExternalLinkSquare } from '@fortawesome/free-solid-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import {
  ExternalLink,
  Icon,
  MetadataDetailsList,
  SearchInstanceDto,
} from '@app/components';

const cnBem = createBemBlockBuilder(['instanceDetailsPage']);

export const getPublishers = ({ publication = [] }: SearchInstanceDto) =>
  publication
    .filter(({ publisher }) => Boolean(publisher))
    .map(({ publisher, place }) => compact([publisher, place]).join(', '));

export const getExternalLink = (title: string, url: string) => (
  <ExternalLink href={url}>
    <Icon className={cnBem('__icon')} icon={faExternalLinkSquare}>
      {title}
    </Icon>
  </ExternalLink>
);

export const renderMetadataList = (data: string[]) => (
  <MetadataDetailsList details={data} />
);
